<template>
    <div class="select-channel-groups">
        <table class="table">
            <tr v-for="group in channelGroups" :key="group.cgid">
                <td class="channel">
                  <label :for="`check-` + group.cgid" class="clickable">{{ group.name }}</label>
                </td>
                <td>
                    <input v-if="onlyOne" type="radio" class="clickable" :value="group.cgid" :id="`check-` + group.cgid" v-model="radio" :disabled="isOmitted(group)"/>
                    <input v-else type="checkbox" class="clickable" :value="group.cgid" :id="`check-` + group.cgid" v-model="selected" :disabled="isOmitted(group)"/>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        name: "SelectChannelGroups",
        props: {
            channelGroups: Array,
            allChecked: Boolean,
            onlyOne:  Boolean,
            omitted: Array,
        },
        data() {
            return {
                selected: [],
                radio: '',
            };
        },
        mounted() {
            if (this.allChecked && !this.onlyOne)
                for (let group of this.channels)
                    this.selected.push(group.cgid);

            this.$forceUpdate();
        },
        methods: {
            getResults() {
                return this.onlyOne ? this.radio : this.selected;
            },
            isOmitted(group) {
                if (this.omitted)
                    for (let om of this.omitted)
                        if (om.cgid == group.cgid)
                            return true;

                return false;
            }
        }
    }
</script>

<style scoped>
    .clickable {
        cursor: pointer;
    }

    .select-groups .table td  {
        padding: 2px 10px;
    }
</style>